<template>
  <div>
    <p>Пользователь с данным email уже существует в нашей системе.</p>
    <p class="font-medium"><span class="font-bold">Имя: </span>{{ user.name }}</p>
    <p class="font-medium"><span class="font-bold">Email: </span>{{ user.email }}</p>
    <p>Сделать пользователя <span class="font-medium">{{ relationText }}</span> данной квартиры?</p>
    <div :class="$style.footer">
      <vs-button class="mr-2" type="flat" @click="modalReject">Нет</vs-button>
      <vs-button @click="modalResolve">Да</vs-button>
    </div>
  </div>
</template>

<script>
import modal from "../../../mixins/modalContext";

export default {
  name:    "UserAppendPopup",
  props:   ['user', 'relationText'],
  mixins:  [modal],
};
</script>

<style lang="scss" module>
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  padding-top: 1rem;
  margin-top: 1rem;

  &:before {
    content: "";
    top: 0;
    position: absolute;
    left: 1rem;
    right: 1rem;
    height: 1px;
    background: #000;
    opacity: .05;
  }

  .btn {
    margin-left: .5rem;
  }
}
</style>
